export default [
  {
    path: '/transfer-nft-record',
    component: () => import('./views/Index'),
    name: 'transfer-nft-record',
    redirect: { name: 'transfer-nft-record-list' },
    children: [
      {
        path: '',
        name: 'transfer-nft-record-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'goga-earn',
        },
      }
    ],
  },
]
